import { useEffect, useState } from "react";
import { Button, Input, Select, Space, message } from "antd";
import TenantApi from "../../../../../../../api/TenantApi";
import TenantDeviceApi from "../../../../../../../api/TenantDeviceApi";
import { AddTenantDeviceWrapper, FormWrapper, OperationWrapper, TenantDeviceInputWrapper, TenantDeviceList, TenantDeviceListBody, TenantDeviceListHeader, TenantDeviceListItem, Title, TitleWrapper } from "./AddTenantDevice.styled";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";


interface AddTenantDeviceProps {
    tenantId?: string,
    onClose: ()=> void,
    onComplete: ()=> void
}

const AddTenantDevice: React.FC<AddTenantDeviceProps> = (props)=> {
    // api
    let tenantApi = new TenantApi();
    let tenantDeviceApi = new TenantDeviceApi();
    const [messageApi, contextHolder] = message.useMessage();
    
    // state
    let [tenantDevices, setTenantDevices] = useState([] as any[]);
    let [tenantOptions, setTenantOptions] = useState([]);
    let [submitEnabled, setSubmitEnabled] = useState(false);

    // event
    let onAddTenantDevice = ()=> {
        let tenantDevice = {
            tenantId: props.tenantId ? props.tenantId: '',
            nodeSn: '',
        };

        tenantDevices.push(tenantDevice);
        setTenantDevices([...tenantDevices]);
    };

    let onRemoveTenantDevice = (index: number)=> {
        tenantDevices.splice(index, 1);
        setTenantDevices([...tenantDevices]);
    };


    let onTenantIdChange = (index: number, selectedValue: string)=> {
        tenantDevices[index].tenantId = selectedValue;
        setTenantDevices([...tenantDevices]);
        validateForm();
    };

    let onNodeSnChange = (index: number, selectedValue: string)=> {
        tenantDevices[index].nodeSn = selectedValue;
        setTenantDevices([...tenantDevices]);
        validateForm();
    };

    let onSubmit = async ()=> {
        await tenantDeviceApi.addTenantDevices(tenantDevices);
        props.onComplete();
        props.onClose();
    };

    let onCancel = ()=> {
        props.onClose();
    };

    // validate
    let validateForm = ()=> {
        for(let tenantDevice of tenantDevices) {
            if(!tenantDevice.nodeSn || !tenantDevice.tenantId) {
                setSubmitEnabled(false);
                return;
            }
        }
        setSubmitEnabled(true);
    }

    let loadTenants = async ()=> {
        let tenants = (await tenantApi.getAll()).data.data;
        let tenantOptions = tenants.map(e=> {
            return {
                label: e.name,
                value: e.id
            };
        });
        setTenantOptions(tenantOptions);
    };
    
    // effect
    useEffect(()=> {
        loadTenants();
    }, []);

    // render
    return (
        <AddTenantDeviceWrapper>
            <TitleWrapper>
                <Title>新增设备</Title>
            </TitleWrapper>

            <FormWrapper>
                <TenantDeviceList>
                    <TenantDeviceListHeader>
                        <TenantDeviceInputWrapper>租户</TenantDeviceInputWrapper>
                        <TenantDeviceInputWrapper>设备序列号</TenantDeviceInputWrapper>
                        <TenantDeviceInputWrapper>操作</TenantDeviceInputWrapper>
                    </TenantDeviceListHeader>
                    <TenantDeviceListBody>
                        {tenantDevices.map((e, index)=> {
                            return <TenantDeviceListItem key={index}>
                                <TenantDeviceInputWrapper>
                                    <Select
                                        placeholder="请选择租户"
                                        value={props.tenantId ? props.tenantId : e.tenantId}
                                        onChange={(selectedValue)=> onTenantIdChange(index, selectedValue)}
                                        options={tenantOptions}
                                        style={{width: '100%'}}
                                    />
                                </TenantDeviceInputWrapper>
                                <TenantDeviceInputWrapper>
                                    <Input value={e.nodeSn} onChange={(ev)=> onNodeSnChange(index, ev.target.value)} placeholder="请输入设备序列号" style={{width: '100%'}}/>
                                </TenantDeviceInputWrapper>
                                <TenantDeviceInputWrapper>
                                    <Button type="link" size="small" onClick={()=> onRemoveTenantDevice(index)}>删除</Button>
                                </TenantDeviceInputWrapper>
                            </TenantDeviceListItem>
                        })}

                        <TenantDeviceListItem>
                            <Button icon={<PlusOutlined />} type="link" onClick={onAddTenantDevice}>添加</Button>
                        </TenantDeviceListItem>
                    </TenantDeviceListBody>
                </TenantDeviceList>
            </FormWrapper>

            <OperationWrapper>
                <Space size="middle">
                    <Button type="primary" disabled={!submitEnabled} onClick={onSubmit}>确定</Button>
                    <Button type="primary" danger onClick={onCancel}>取消</Button>
                </Space>
            </OperationWrapper>
        </AddTenantDeviceWrapper>
    )
}

export default AddTenantDevice;
